import { City, CityId } from '../models/city';

export const CITY_LIST: ReadonlyArray<City> = [
  {
    id: CityId.Larnaca,
    title: 'Larnaca',
  },
  {
    id: CityId.Limassol,
    title: 'Limassol',
  },
  {
    id: CityId.Nicosia,
    title: 'Nicosia',
  },
  {
    id: CityId.Paphos,
    title: 'Paphos',
  },
  {
    id: CityId.Famagusta,
    title: 'Famagusta',
  },
];
